const sizes = {
  header_height: '4.8rem',
  footer_height: '4rem',
  navbar_vertical_padding: '0.5rem',
  navbar_horizontal_padding: '2rem',
  section_padding: '1rem',
};

export default sizes;
